@if (this.bewegung(); as bewegung) {
  <div class="flex flex-col overflow-auto full-width w-full z-[0] lg:-mt-3 relative">
    @if ((loading$ | async) === false) {
      <div
        class="flex flex-col w-full -mt-2 p-4">
        <soft-artikel-header [bewegung]="bewegung" [palette]="palette()" [paletteEinzelEingabe]="paletteEinzelEingabe"></soft-artikel-header>
      </div>
    } @else {
      <div class="p-4">
        <div class="flex flex-col gap-2" *softRepeat="2">
          <div class="h-4 w-16 skeleton rounded"></div>
          <div class="flex soft-card rounded w-full h-24 mb-3">
            <div class="flex flex-col gap-2 items-start pb-1.5 pt-2">
              <div class="h-4 w-20 skeleton rounded"></div>
              <div class="h-4 w-24 skeleton rounded"></div>
              <div class="h-4 w-36 skeleton rounded"></div>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-2 mt-3" *softRepeat="3">
          <div class="h-4 w-16 skeleton rounded"></div>
          <div class="flex rounded bg-white w-full h-24"></div>
        </div>
      </div>
    }
  </div>
}
<router-outlet></router-outlet>
